import { useSetRecoilState } from 'recoil'
import { isInViewFooterState } from '../states/messageState'
import { windowScrollToBottom } from '../util/windowScrollToBottom'

export const useInViewFooter = () => {
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)

  const handleInViewFooter = () => {
    setTimeout(() => {
      setIsInViewFooter(true)
      windowScrollToBottom()
    }, 3000)
  }

  return { handleInViewFooter }
}
